/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {alignItems: 'flex-start'},
        label: {
            width: 'full'
        },
        icon: {
            width: '10px',
            height: '100%',
        },
        control: {
            width: '15px',
            height: '15px',
            mt: '2px',
            borderWidth: '1px',
            flexShrink: 0,
            borderRadius: 0,
            borderColor: 'webTheme.iconPrimary',
            '& + .chakra-checkbox__label': {
                textStyle: 'bodySmRegular'
            },
            _checked: {
                backgroundColor: 'webTheme.iconPrimary',
                borderColor: 'webTheme.iconPrimary',
                '& .chakra-checkbox__icon, & .chakra-icon, & svg': {
                    width: '10px',
                    height: '100%'
                },
                _hover: {
                    bg: 'webTheme.iconPrimary',
                    borderColor: 'webTheme.iconPrimary'
                }
            },
            _disabled: {
                backgroundColor: 'webTheme.backgroundDefault',
                borderColor: 'webTheme.iconDisabled',
                '& + .chakra-checkbox__label': {
                    color: 'webTypo.textDisabled'
                },
                _checked: {
                    backgroundColor: 'webTheme.iconDisabled',
                    borderColor: 'webTheme.iconDisabled',
                    '& .chakra-checkbox__icon, & .chakra-icon, & svg': {
                        color: 'webTheme.backgroundDefault'
                    },
                    _before: {
                        background: 'webTheme.iconDisabled'
                    }
                }
            }
        }
    },
    sizes: {
        md: {
            label: {fontSize: 'sm'}
        }
    },
    variants: {
        filters: {
            control: {
                borderWidth: '1px'
            }
        }
    }
}
